
import http from '@/http';

const setList =  async (context) =>{

     try{

        const response =  await http.get("/adm/company")
        context.commit("SET_LIST",response.data)


     } catch(err ){
            window.console.log(err)
     }

}

const setByID =  async (context,id) =>{

    try{

       const data = ( await http.get(`/adm/company/${id}`) ).data
       context.commit("SET_BYID",data)


    } catch(err ){
           window.console.log(err)
    }

}

const setRemove =  async (context,id) =>{

    try{

       await http.delete(`/adm/company/${id}`)
       context.dispatch("setList")


    } catch(err ){
           window.console.log(err)
    }

}

const checkForm = async (context, payload)=>{

    let response

    var method = "post"
    var action = "/company"

    if(payload.id){
        method = "put"
        action = `/adm/company/${payload.id}`
    }

    try{

        response  = await http[method](action, payload)
        context.commit("CHECK_FORM",response.status)
 
 
     } catch(err ){
            window.console.log(err)
     }

}

const setToken =  async (context,id) =>{

    try{

       const response = await http.get(`/adm/company/${id}/token`)
        
       if(response.status == 201){
            const href = `/#/empresa/token?access_token=${response.data.token}`
            window.open(href,"_black")
       }


    } catch(err ){
           window.console.log(err)
    }

}

export default {
    setList,
    setByID,
    checkForm, 
    setRemove,
    setToken, 
}